import classes from './Soon.module.css'

const Soon = ({top,font,position,bottom}) => {
    return (
        <div className={classes.Soon}  style={{ top: `${top}` , position:`${position}`, bottom:`${bottom}`}}>
            <div className={classes.SoonText}  style={{ fontSize: `${font}` }}>בקרוב</div>
        </div>

    )

}
export default Soon
